export class ValidateResourceConfigurationRequest {
    'resourceId';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceId",
            "baseName": "resourceId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ValidateResourceConfigurationRequest.attributeTypeMap;
    }
    constructor() {
    }
}
